import { render, staticRenderFns } from "./WidgetPurse.vue?vue&type=template&id=479d2fc8"
import script from "./WidgetPurse.vue?vue&type=script&lang=js"
export * from "./WidgetPurse.vue?vue&type=script&lang=js"
import style0 from "./WidgetPurse.vue?vue&type=style&index=0&id=479d2fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports